import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RoblexModalConfig } from '../../../config/modal/modal.config';
import { RoblexModalRef } from '../../../config/modal/modal.ref';

@Component({
    selector: 'roblex-modal-header',
    templateUrl: './modal-header.component.html',
    styleUrls: ['./modal-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ModalHeaderComponent implements OnInit {
    isLeave: boolean;
    /**
     * Creates an instance of modal header component.
     * @param roblexModalRef RoblexModalRef
     * @param roblexModalConfig RoblexModalConfig
     */
    constructor(
        private roblexModalRef: RoblexModalRef,
        public roblexModalConfig: RoblexModalConfig
    ) {}
    /**
     * on init
     */
    ngOnInit(): void {
        this.isLeave = this.roblexModalConfig.isLeave;
    }
    /**
     * Determines whether click close on
     */
    onClickClose() {
        this.roblexModalRef.close();
    }
}
